import moment from 'moment';
import { DATE_FORMAT_READABLE, DATE_PICKER_FORMAT } from "./constants";

export function readableDate(dateString: string): string {
  return moment(dateString, "YYYY-MM-DD").format(DATE_FORMAT_READABLE);
}

export function datePickerDate(dateString: string): string {
  return moment(dateString, "YYYY-MM-DD").format(DATE_PICKER_FORMAT);
}

export enum States {
  SA = "1",
  WA = "2",
  NT = "3",
  QLD = "4",
  NSW = "5",
  VIC = "6",
  TAS = "7",
  ACT = "8",
}

export function calculateDates(startDate: string, endDate: string): string[] {
  if (startDate === endDate) {
    return [startDate];
  }

  let dates = [];

  let start = moment(startDate);
  let end = moment(endDate);
  let days = end.diff(start, 'days');

  for (let i = 0; i <= days; i++) {
    let date = start.clone().add(i, 'days').format('YYYY-MM-DD');

    dates.push(date);
  }

  return dates;
};